export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative w-full bg-background-50">
      <div className="border-t border-foreground-200/60" />

      {/* Brand Logo & Nav */}
      <div className="w-full px-6 md:px-16 py-20 md:py-24 flex flex-col items-center justify-center">
        <img
          src="https://storage.readdy-site.link/project_files/08d9908a-2395-4ac3-82a1-6049451d0d9d/880ffd8e-de16-4e33-8809-efab8f30f9a5_compressed_main_logo_pc2x.webp"
          alt="GIAZO"
          className="h-8 md:h-10 w-auto object-contain mb-4"
        />
        <p
          className="font-sans text-[16px] md:text-[18px] tracking-[0.12em] text-foreground-500 mb-12"
          style={{ fontWeight: 300 }}
        >
          その開放感、プレミアム。
        </p>

        {/* Brand Info */}
        <button
          onClick={scrollToTop}
          className="inline-flex flex-col items-center gap-1 cursor-pointer group mb-16"
        >
          <span className="w-8 h-8 flex items-center justify-center">
            <i className="ri-arrow-up-line text-lg text-foreground-600 group-hover:text-foreground-950 transition-colors duration-300"></i>
          </span>
          <span className="font-sans text-[13px] tracking-[0.15em] text-foreground-400 group-hover:text-foreground-950 transition-colors duration-300">
            TOP
          </span>
        </button>

        <div className="flex flex-col items-center gap-4">
          <p
            className="font-sans text-[13px] tracking-[0.08em] text-foreground-600"
            style={{ fontWeight: 300 }}
          >
            COPYRIGHT (C) SOKEN HOME ALL RIGHTS RESERVED.
          </p>
        </div>
      </div>
    </footer>
  );
}